import { mediaTypeFromFileName } from "../../../shared/fileMediaTypes";
import type { ChatOutputView } from "../../tools";
import { useToolOutput } from "../../hooks/useToolOutput";
import { parseChatOutputView } from "../../tools/ShowOutput";
import { EmptyState } from "../EmptyState";
import { FileList, FileListRow } from "../FileList";
import { StepDetails } from "../StepDetails";
import type { ChatOutput } from "./chatOutputs";

function OutputFileRow({
  output,
  onShowOutput,
}: {
  output: ChatOutput;
  onShowOutput: (output: ChatOutputView) => void;
}) {
  const { output: result } = useToolOutput(output.entryId, true);
  const parsed = parseChatOutputView(output.toolName, result);
  const metadata = parsed?.key === output.key ? parsed : null;
  const inferredType = mediaTypeFromFileName(output.fileName);
  const mediaType =
    metadata?.mediaType && metadata.mediaType !== "application/octet-stream"
      ? metadata.mediaType
      : inferredType;
  return (
    <FileListRow
      name={output.fileName}
      mediaType={mediaType}
      sizeBytes={metadata?.sizeBytes}
      thumbnailUrl={output.thumbnailUrl}
      onPress={() =>
        onShowOutput({
          key: output.key,
          url: output.url,
          thumbnailUrl: output.thumbnailUrl,
          fileName: output.fileName,
          mediaType,
          sizeBytes: metadata?.sizeBytes ?? 0,
        })
      }
    />
  );
}

export function OutputsList({
  outputs,
  onShowOutput,
}: {
  outputs: ChatOutput[];
  onShowOutput: (output: ChatOutputView) => void;
}) {
  if (outputs.length > 0) {
    return (
      <FileList title="Files" count={outputs.length}>
        {outputs.map((output) => (
          <OutputFileRow
            key={output.key}
            output={output}
            onShowOutput={onShowOutput}
          />
        ))}
      </FileList>
    );
  }
  return (
    <StepDetails
      embedded
      heading={null}
      flushBody
      body={
        <EmptyState
          iconName="folder"
          title="No files yet"
          description="Files from this chat will appear here."
        />
      }
    />
  );
}
